import React from 'react';
import { Flex, Box, Text, Image, Button } from '@chakra-ui/react';

import { FaSignOutAlt, FaSignInAlt } from 'react-icons/fa';
import { SiGoogle } from 'react-icons/si';
import { googleSignin, signOut } from '../services/authService';
import useCurrentUser from '../hooks/useCurrentUser';

import nextonLogo from '../images/nexton-logo.png';
import bgLogin from '../images/bg-login.svg';

export default function Welcome({ status }) {
  const { loading, loaded, isAuthenticated } = useCurrentUser();

  let title;
  let message;
  switch (status) {
    case 'signedOut':
      title = 'Welcome!';
      message = 'Please Sign In';
      break;
    case 'signedIn':
      title = 'Welcome!';
      message = 'You are Signed In';
      break;
    case 'interviews':
      title = 'Welcome!';
      message = 'Please Sign in to access the Interview List';
      break;
    case undefined:
      title = '404';
      message = `The page doesn't exist or you can't access it!`;
      break;
    default:
      title = '404';
      message = `The page ${status} doesn't exist or you can't access it!`;
      break;
  }

  return (
    <div
      style={{
        backgroundImage: `url('${bgLogin}')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        width: '100%',
        height: '100vh',
      }}
      className='w-full h-[100vh] relative'>
      <Flex
        justifyContent='space-between'
        flexWrap='wrap'
        mx='auto'
        pl={['20px', '20px', '100px']}
        pt={['50px', '50px', '50px']}>
        <Box
          textAlign={['center', 'center', 'right']}
          mt={['40px', '40px', '48px', '64px']}
          width={['100%', '100%', '50%']}
          display='flex'
          flexDirection='column'
          alignItems='flex-start'>
          <Flex justifyContent={['center', 'center', 'end']}>
            <Image
              src={nextonLogo}
              alt='Nexton Logo'
              width={['178px', '178px', 'unset']}
              mb={['16px', '16px', '28px']}
            />
          </Flex>

          <Text fontSize={['20px', '20px', '28px']} fontWeight='500' fontFamily='K2D, sans-serif' color='gray.500'>
            Screeners Platform
          </Text>

          <Text
            fontSize={['52px', '52px', '64px']}
            fontWeight='500'
            fontFamily='K2D, sans-serif'
            color='green.500'
            lineHeight='1.1'
            mt={['48px', '48px', '64px']}
            mb='12px'>
            {title}
          </Text>
          <Text
            fontSize={['28px']}
            fontWeight='500'
            lineHeight='1.3'
            color='blue.500'
            fontFamily='K2D, sans-serif'
            maxWidth='350px'
            textAlign='left'
            mb={['44px', '44px', '64px']}>
            {loading ? 'Signing in...' : message}
          </Text>

          {!isAuthenticated && !loading && (
            <Button
              size='lg'
              colorScheme='blue'
              leftIcon={<SiGoogle />}
              rightIcon={<FaSignInAlt />}
              onClick={() => googleSignin()}>
              SIGN IN WITH GOOGLE
            </Button>
          )}

          {!isAuthenticated && loading && (
            <Button size='lg' colorScheme='blue' rightIcon={<FaSignInAlt />}>
              SIGNIN IN...
            </Button>
          )}
          {isAuthenticated && loaded && (
            <Button size='lg' colorScheme='blue' rightIcon={<FaSignOutAlt />} onClick={() => signOut()}>
              SIGN OUT
            </Button>
          )}
        </Box>
      </Flex>
    </div>
  );
}
